export class InjectionToken {
  static IFeatureRepository = Symbol("IFeatureRepository");
  static IAppTransactionRepository = Symbol("IAppTransactionRepository");
  static ICarrierRepository = Symbol("ICarrierRepository");
  static ICategoryRepository = Symbol("ICategoryRepository");
  static ApiDocumentViewModel = Symbol("ApiDocumentViewModel");
  static ISupportFeatureRepository = Symbol("ISupportFeatureRepository");
  static SupportFeatureViewModel = Symbol("SupportFeatureViewModel");
  static IFilterFeatureRepository = Symbol("IFilterFeatureRepository");
  static INotificationRepository = Symbol("INotificationRepository");
  static NotificationViewModel = Symbol("NotificationViewModel");
  static ITopupManagementRepository = Symbol("ITopupManagementRepository");
  static PackageManagementViewModel = Symbol("PackageManagementViewModel");
  static IRoamingPartnerRepository = Symbol("IRoamingPartnerRepository");
  static IPartnerManagementRepository = Symbol("IPartnerManagementRepository");
  static IStoreRepository = Symbol("IStoreRepository");
  static IB2BAccountRepository = Symbol("IB2BAccountRepository");
  static IB2BPartnerRepository = Symbol("IB2BPartnerRepository");
  static IChangePasswordRepository = Symbol("IChangePasswordRepository");
  static IRoleRepository = Symbol("IRoleRepository");

  static generateToken(token: string) {
    return Symbol(token);
  }
}
